import React from "react";
import TableViewer from "../../TableViewer";
import { translate } from "../../../utils/useful";

class SalesItem extends React.Component {
    state = {
        chart: [
            {
                // img: '/assets/icons/line.svg',
                step: '0',
                itemname: '{{lang}}test'
                // step: '5'
            },
            {
                itemname: '{{lang}}test',
                // img: '/assets/icons/Group 4.svg',
                step: '1'
            },
            {
                itemname: '{{lang}}test',
                // img: '/assets/icons/bar.svg',
                step: '2'
            },
            {
                itemname: '{{lang}}test',
                // img: '/assets/icons/rating.svg',
                step: '3'
            },
            {
                itemname: '{{lang}}test',
                // img: '/assets/icons/table.svg',
                step: '4'
            },
        ],

        headers: [
            { key: 'itemname', type: 'TextInput', information: { label: '{{lang}}ITEM NAME' } },
            { key: 'average price', type: 'TextInput', information: { label: '{{lang}}AVERAGE PRICE' } },
            { key: 'quantity sold', type: 'TextInput', information: { label: '{{lang}}QUANTITY SOLD' } },
            { key: 'amount', type: 'TextInput', information: { label: '{{lang}}AMOUNT' } },
            // { key: 'cDate', type: 'DateInput', information: { label: 'Creation Date' } },
            // { key: 'restrictions', type: 'TextInput', information: { label: 'Restrictions' } },
        ],

    }
    render() {
        return (
            <div className="mx-3">

                <div className="flexcc flex-column">
                    <p style={{ fontSize: 12 }}>{translate('test')}</p>
                    <p>{translate('Sales by Item')}</p>
                    {/* <div className="d-flex align-items-center mt-1">
                        <p style={{ fontSize: 12 }}>Basis: </p>&nbsp;
                        <p style={{ fontSize: 12 }}>Accrual</p>
                    </div> */}
                    <div className="d-flex align-items-center mt-1">
                        <p style={{ fontSize: 12 }}>{translate('From')}</p>&nbsp;
                        <p style={{ fontSize: 12 }}>2023/01/01</p>&nbsp;
                        <p style={{ fontSize: 12 }}>{translate('Up to')}</p>&nbsp;
                        <p style={{ fontSize: 12 }}>2023/01/31</p>&nbsp;
                    </div>
                </div>
                <div className="my-3">
                    <div style={{ display: 'flex', justifyContent: 'flex-end', }}>
                        <p style={{ color: '#408dfb', fontSize: 13 }}>{translate('+ Add Temporary Note')}</p>
                    </div>
                </div>
                <div>
                    <TableViewer
                        // isLoading={this.state.isLoading}
                        headers={this.state.headers}
                        data={this.state.chart}
                        // actions={this.state.actions}
                        // settings={{ isSortable: false }}
                        // openEditModal={this.openEditModal}
                        // openRemoveModal={this.openRemoveModal}
                        // updateData={this.updateData}
                        ref={el => this.TableViewer = el}
                    />
                </div>
                {/* <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                <div className="flexcb">
                    <div>
                        <p style={{ fontSize: 14 }}>
                            Account
                        </p>
                    </div>
                    <div>
                        <p style={{ fontSize: 14 }}>
                            Total
                        </p>
                    </div>
                </div>
                <div className="my-1" style={{ borderBottom: '1px solid #dadada' }} />

                <div className="">
                    <div className="flexcb mt-2">
                        <div className="">
                            <p style={{ fontSize: 13 }}>Opening Balance</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13 }}>0.0</p>
                        </div>

                    </div>
                    <div className="mt-2">
                        <p style={{ fontSize: 13, fontWeight: 'bold' }}>Changes in Equity</p>
                    </div>
                    <div className="flexcb mt-2">
                        <div>
                            <p style={{ fontSize: 13, }}>Net Changes in Equity</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13, }}>0.0</p>
                        </div>

                    </div>

                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />

                <div className="flexcb mt-2">
                    <div>
                        <p style={{ fontSize: 13 }}>Closing Balance	</p>
                    </div>
                    <div>
                        <p style={{ fontSize: 13 }}>0.0</p>
                    </div>

                </div> */}
                {/* <div className="">
                    <div className="flexcb mt-2">
                        <div>
                            <p style={{ fontSize: 13 }}>Accounts Receivable</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13 }}>0.0</p>
                        </div>

                    </div>
                    <div className="mt-2">
                        <p style={{ fontSize: 13, fontWeight: 'bold' }}>Other current assets</p>
                    </div>
                    <div className="flexcb mt-2">
                        <div className="mld-3">
                            <p style={{ fontSize: 13, color: '#408dfb' }}>Employee Advance</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13 }}>0.0</p>
                        </div>

                    </div>
                    <div className="flexcb mt-2">
                        <div className="">
                            <p style={{ fontSize: 13, }}>Total for Other current assets</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13 }}>0.0</p>
                        </div>

                    </div>

                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                <div className="flexcb mt-2">
                    <div className="">
                        <p style={{ fontSize: 13, }}>Total for Current Assets</p>
                    </div>
                    <div>
                        <p style={{ fontSize: 13 }}>0.0</p>
                    </div>

                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                <div className="flexcb mt-2">
                    <div className="">
                        <p style={{ fontSize: 13, }}>Total for Assets</p>
                    </div>
                    <div>
                        <p style={{ fontSize: 13 }}>0.0</p>
                    </div>

                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                <div className="">
                    <div className="mt-2">
                        <p style={{ fontSize: 13, fontWeight: 'bold' }}>Liabilities & Equities</p>
                    </div>
                    <div className="mt-2">
                        <p style={{ fontSize: 13, fontWeight: 'bold' }}>Equities</p>
                    </div>
                    <div className="flexcb mt-2">
                        <div className="mld-3">
                            <p style={{ fontSize: 13, color: '#408dfb' }}>Current Year Earnings</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13, color: '#408dfb' }}>0.0</p>
                        </div>

                    </div>
                    <div className="flexcb mt-2">
                        <div>
                            <p style={{ fontSize: 13, }}>Total for Equities</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13, }}>0.0</p>
                        </div>

                    </div>

                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />

                <div className="flexcb mt-2">
                    <div>
                        <p style={{ fontSize: 13, }}>Total for Liabilities & Equities	</p>
                    </div>
                    <div>
                        <p style={{ fontSize: 13, }}>0.0</p>
                    </div>

                </div> */}
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                {/* <div className="flexcb">
                    <div></div>
                    <div><p style={{ fontSize: 13, fontWeight: 'bold' }}>Net Change in cash	</p></div>
                    <div><p style={{ fontSize: 13 }}>0.0</p></div>
                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                <div className="flexcb">
                    <div></div>
                    <div><p style={{ fontSize: 13, fontWeight: 'bold' }}>Ending Cash Balance	</p></div>
                    <div><p style={{ fontSize: 13 }}>0.0</p></div>
                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} /> */}

            </div>
        )
    }
}


export default SalesItem;